// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ExpireCard_card__M1VYj {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
}
.ExpireCard_inner__Dm6PF {
  display: flex;
  position: relative;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  width: 100%;
  border-radius: 24px;
  border: 2px solid rgba(255, 255, 255, 0.24);
  background: rgba(67, 62, 61, 0.88);
  color: #fff;
  max-width: 500px;
  min-width: 320px;
  min-height: 150px;
}
.ExpireCard_content__zPa4r {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  /* background-image: url(/public/assets/layout/login-lone-mobile.png); */
  background-size: cover;
  background-position: center;
  padding: 1rem;
}
.ExpireCard_title__JurHZ {
  color: #fef1c5;
  text-align: center;
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
  margin-bottom: 12px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  width: 100%;
  gap: 4px;
}
.ExpireCard_title__JurHZ img {
  width: 16px;
  height: 16px;
}
.ExpireCard_code__KC9H- {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  min-height: 48px;
  width: 100%;
  padding: 8px 16px;
  margin-bottom: 12px;
  gap: 8px;
  border-radius: 8px;
  background: rgba(0, 0, 0, 0.25);
  backdrop-filter: blur(4px);
}
.ExpireCard_code-right__LNvPs {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  flex-basis: 65%;
}
.ExpireCard_code-right_title__hDBCo {
  text-align: right;
  font-size: 12px;
  font-style: normal;
  font-weight: 600;
  line-height: 20px;
}
.ExpireCard_code-right_coupon__s\\+TjO {
  text-align: right;
  font-family: "poppins";
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  background: unset;
  width: 100px;
  color: rgba(255, 255, 255, 0.4);
}
.ExpireCard_code-left__DyFuk {
  text-align: center;
  /* font-family: Yekan Bakh FaNum; */
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 4px;
  cursor: pointer;
  /* width: 31%; */
}
.ExpireCard_code-left__DyFuk img {
  width: 24px;
  height: 24px;
}
.ExpireCard_code-left_icon__k\\+Ol7 {
}
.ExpireCard_code-left_copy__Tm7T5 {
}
.ExpireCard_description__zYKKW {
  text-align: center;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  margin-bottom: 8px;
}
.ExpireCard_expire__yYNna {
  text-align: center;
  font-size: 12px;
  font-style: normal;
  font-weight: 600;
  line-height: 20px;
  border-radius: 8px;
  padding: 2px 4px;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 4px;
}

.ExpireCard_expire-wrapper__f7f0m {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

@media screen and (min-width: 1000px) {
  .ExpireCard_title__JurHZ {
    font-size: 18px;
  }
  .ExpireCard_code-right_title__hDBCo,
  .ExpireCard_code-left__DyFuk {
    font-size: 16px;
  }
  .ExpireCard_description__zYKKW,
  .ExpireCard_expire__yYNna,
  .ExpireCard_code-right_coupon__s\\+TjO {
    font-size: 14px;
  }
  .ExpireCard_code__KC9H- {
    min-height: 58px;
  }
  .ExpireCard_code-right_coupon__s\\+TjO {
    width: 150px;
  }
  .ExpireCard_buy__UZLIO {
    font-size: 14px;
  }
  .ExpireCard_inner__Dm6PF {
    max-width: 500px;
    min-width: 380px;
    min-height: 212px;
    justify-content: space-between;
  }
  .ExpireCard_card__M1VYj {
    width: 32%;
  }
}
@media screen and (max-width: 380px) {
  .ExpireCard_code-right_title__hDBCo {
    font-size: 12px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/DiscountCard/ExpireCard/ExpireCard.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;AACb;AACA;EACE,aAAa;EACb,kBAAkB;EAClB,uBAAuB;EACvB,mBAAmB;EACnB,sBAAsB;EACtB,WAAW;EACX,mBAAmB;EACnB,2CAA2C;EAC3C,kCAAkC;EAClC,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,wEAAwE;EACxE,sBAAsB;EACtB,2BAA2B;EAC3B,aAAa;AACf;AACA;EACE,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,2BAA2B;EAC3B,mBAAmB;EACnB,WAAW;EACX,QAAQ;AACV;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,sBAAsB;EACtB,gBAAgB;EAChB,WAAW;EACX,iBAAiB;EACjB,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,+BAA+B;EAC/B,0BAA0B;AAC5B;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,uBAAuB;EACvB,eAAe;AACjB;AACA;EACE,iBAAiB;EACjB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,iBAAiB;EACjB,sBAAsB;EACtB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;EACjB,YAAY;EACZ,+BAA+B;AACjC;AACA;EACE,kBAAkB;EAClB,mCAAmC;EACnC,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,YAAY;AACd;AACA;AACA;AACA;AACA;AACA;EACE,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE;IACE,eAAe;EACjB;EACA;;IAEE,eAAe;EACjB;EACA;;;IAGE,eAAe;EACjB;EACA;IACE,gBAAgB;EAClB;EACA;IACE,YAAY;EACd;EACA;IACE,eAAe;EACjB;EACA;IACE,gBAAgB;IAChB,gBAAgB;IAChB,iBAAiB;IACjB,8BAA8B;EAChC;EACA;IACE,UAAU;EACZ;AACF;AACA;EACE;IACE,eAAe;EACjB;AACF","sourcesContent":[".card {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 100%;\n}\n.inner {\n  display: flex;\n  position: relative;\n  justify-content: center;\n  align-items: center;\n  flex-direction: column;\n  width: 100%;\n  border-radius: 24px;\n  border: 2px solid rgba(255, 255, 255, 0.24);\n  background: rgba(67, 62, 61, 0.88);\n  color: #fff;\n  max-width: 500px;\n  min-width: 320px;\n  min-height: 150px;\n}\n.content {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  width: 100%;\n  /* background-image: url(/public/assets/layout/login-lone-mobile.png); */\n  background-size: cover;\n  background-position: center;\n  padding: 1rem;\n}\n.title {\n  color: #fef1c5;\n  text-align: center;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: normal;\n  margin-bottom: 12px;\n  display: flex;\n  justify-content: flex-start;\n  align-items: center;\n  width: 100%;\n  gap: 4px;\n}\n.title img {\n  width: 16px;\n  height: 16px;\n}\n.code {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex-direction: column;\n  min-height: 48px;\n  width: 100%;\n  padding: 8px 16px;\n  margin-bottom: 12px;\n  gap: 8px;\n  border-radius: 8px;\n  background: rgba(0, 0, 0, 0.25);\n  backdrop-filter: blur(4px);\n}\n.code-right {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: flex-start;\n  flex-basis: 65%;\n}\n.code-right_title {\n  text-align: right;\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: 20px;\n}\n.code-right_coupon {\n  text-align: right;\n  font-family: \"poppins\";\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 20px;\n  background: unset;\n  width: 100px;\n  color: rgba(255, 255, 255, 0.4);\n}\n.code-left {\n  text-align: center;\n  /* font-family: Yekan Bakh FaNum; */\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: 20px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 4px;\n  cursor: pointer;\n  /* width: 31%; */\n}\n.code-left img {\n  width: 24px;\n  height: 24px;\n}\n.code-left_icon {\n}\n.code-left_copy {\n}\n.description {\n  text-align: center;\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 400;\n  line-height: 20px;\n  margin-bottom: 8px;\n}\n.expire {\n  text-align: center;\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: 20px;\n  border-radius: 8px;\n  padding: 2px 4px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 4px;\n}\n\n.expire-wrapper {\n  width: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n@media screen and (min-width: 1000px) {\n  .title {\n    font-size: 18px;\n  }\n  .code-right_title,\n  .code-left {\n    font-size: 16px;\n  }\n  .description,\n  .expire,\n  .code-right_coupon {\n    font-size: 14px;\n  }\n  .code {\n    min-height: 58px;\n  }\n  .code-right_coupon {\n    width: 150px;\n  }\n  .buy {\n    font-size: 14px;\n  }\n  .inner {\n    max-width: 500px;\n    min-width: 380px;\n    min-height: 212px;\n    justify-content: space-between;\n  }\n  .card {\n    width: 32%;\n  }\n}\n@media screen and (max-width: 380px) {\n  .code-right_title {\n    font-size: 12px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"card": `ExpireCard_card__M1VYj`,
	"inner": `ExpireCard_inner__Dm6PF`,
	"content": `ExpireCard_content__zPa4r`,
	"title": `ExpireCard_title__JurHZ`,
	"code": `ExpireCard_code__KC9H-`,
	"code-right": `ExpireCard_code-right__LNvPs`,
	"code-right_title": `ExpireCard_code-right_title__hDBCo`,
	"code-right_coupon": `ExpireCard_code-right_coupon__s+TjO`,
	"code-left": `ExpireCard_code-left__DyFuk`,
	"code-left_icon": `ExpireCard_code-left_icon__k+Ol7`,
	"code-left_copy": `ExpireCard_code-left_copy__Tm7T5`,
	"description": `ExpireCard_description__zYKKW`,
	"expire": `ExpireCard_expire__yYNna`,
	"expire-wrapper": `ExpireCard_expire-wrapper__f7f0m`,
	"buy": `ExpireCard_buy__UZLIO`
};
export default ___CSS_LOADER_EXPORT___;
